import Layout from "../components/Layout";
import ProductPreview from "../components/ProductPreview";
import PropTypes from "prop-types";
import React from "react";
import { graphql } from "gatsby";

const SeasonRow = ({ title, products }) => (
  <div className="mg-top-2">
    <h3 className="is-size-6 has-text-weight-bold brand-color">{title}</h3>
    <div className="columns mg-btm-2 is-multiline">
      {products.map(product => (
        <ProductPreview
          key={product.productName}
          className="column is-3"
          title={product.productName}
          imageUrl={product.productImage}
        />
      ))}
    </div>
  </div>
);

export class SeasonPageTemplate extends React.Component {
  render() {
    const { categories, banner, video } = this.props;
    console.log(banner, video);

    return (
      <div>
        <div>
          <video className="full-w" loop muted autoPlay poster={banner}>
            <source src={video} type="video/mp4" />
          </video>
        </div>

        <div className="has-background-white-bis section">
          <div className="container">
            <div className="column is-8 is-offset-2">
              {categories.map(c => (
                <SeasonRow
                  title={c.categoryName}
                  key={c.categoryName}
                  products={c.product || []}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SeasonPageTemplate.propTypes = {
  title: PropTypes.string,
  categories: PropTypes.array
};

const SeasonPage = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <Layout>
      <SeasonPageTemplate
        title={post.frontmatter.title}
        banner={post.frontmatter.banner}
        video={post.frontmatter.video}
        categories={post.frontmatter.category}
      />
    </Layout>
  );
};

SeasonPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object
  })
};

export default SeasonPage;
export const seasonPageQuery = graphql`
  query SeasonPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        banner {
          childImageSharp {
            fluid(maxWidth: 1360) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        video {
          publicURL
        }
        category {
          categoryName
          product {
            productName
            productImage {
              childImageSharp {
                fluid(maxWidth: 1360) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`;
